import { Skeleton } from "@/components/ui";

/**
 * Skeletons compuestos para estados de carga consistentes en toda la SPA.
 * Cada primitivo refleja un patrón visual: KPI grid, list, detail header, form.
 */

export function KpiSkeleton({ count = 4 }: { count?: number }) {
  return (
    <div className={`grid grid-cols-2 lg:grid-cols-${count} gap-3 mb-6`}>
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="rounded-lg border border-border bg-surface p-4">
          <Skeleton width={120} height={11} className="mb-2" />
          <Skeleton width={88} height={28} className="mb-1.5" />
          <Skeleton width={140} height={11} />
        </div>
      ))}
    </div>
  );
}

export function CardListSkeleton({ rows = 4 }: { rows?: number }) {
  return (
    <ul className="divide-y divide-border">
      {Array.from({ length: rows }).map((_, i) => (
        <li key={i} className="py-3 flex items-start gap-3">
          <Skeleton width={32} height={32} rounded="full" />
          <div className="flex-1 min-w-0">
            <Skeleton width="60%" height={14} className="mb-2" />
            <Skeleton width="40%" height={11} />
          </div>
          <Skeleton width={56} height={11} />
        </li>
      ))}
    </ul>
  );
}

export function DetailHeaderSkeleton() {
  return (
    <div className="mb-6">
      <Skeleton width={120} height={11} className="mb-3" />
      <Skeleton width="60%" height={32} className="mb-3" />
      <Skeleton width="40%" height={14} />
    </div>
  );
}

export function FormSkeleton({ fields = 4 }: { fields?: number }) {
  return (
    <div className="space-y-4">
      {Array.from({ length: fields }).map((_, i) => (
        <div key={i}>
          <Skeleton width={120} height={11} className="mb-1.5" />
          <Skeleton width="100%" height={40} rounded="lg" />
        </div>
      ))}
    </div>
  );
}

export function GridCardSkeleton({ count = 6 }: { count?: number }) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="rounded-lg border border-border bg-surface p-4">
          <div className="flex items-start justify-between gap-2 mb-3">
            <div className="flex-1 min-w-0">
              <Skeleton width={56} height={10} className="mb-2" />
              <Skeleton width="80%" height={16} />
            </div>
            <Skeleton width={56} height={56} rounded="full" />
          </div>
          <Skeleton width="100%" height={11} className="mb-1" />
          <Skeleton width="60%" height={11} />
          <div className="flex items-center justify-between mt-3">
            <Skeleton width={70} height={18} rounded="full" />
            <Skeleton width={60} height={11} />
          </div>
        </div>
      ))}
    </div>
  );
}

export function TwoColumnDetailSkeleton() {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-5">
      <div className="lg:col-span-2 rounded-lg border border-border bg-surface p-5">
        <Skeleton width={180} height={16} className="mb-3" />
        <Skeleton width="100%" height={11} className="mb-1.5" />
        <Skeleton width="90%" height={11} className="mb-1.5" />
        <Skeleton width="75%" height={11} className="mb-4" />
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
          {Array.from({ length: 4 }).map((_, i) => (
            <div key={i}>
              <Skeleton width={80} height={10} className="mb-1.5" />
              <Skeleton width={60} height={18} />
            </div>
          ))}
        </div>
      </div>
      <div className="rounded-lg border border-border bg-surface p-5">
        <Skeleton width={120} height={16} className="mb-4" />
        <div className="flex gap-1.5 mb-2">
          {Array.from({ length: 5 }).map((_, i) => (
            <Skeleton key={i} width={28} height={28} rounded="full" />
          ))}
        </div>
        <Skeleton width={80} height={11} />
      </div>
    </div>
  );
}
